<template>
    <st-modal
        ref="st-edit-tax-modal"
        hideable
        hide-footer
        hide-header-delimiter
        hide-footer-delimiter
        no-close-on-backdrop
        no-close-on-esc
        size="md"
        :hideHeaderClose="loading"
        :title="$t('TAXES.MODALS.EDIT_TITLE')"
    >
        <template #body>
            <tax-form
                @cancelForm="hide"
                @submitForm="submit"
                :tax="selectedItem"
            >
                <template #buttons="{ submit, cancel }">
                    <div class="d-flex justify-content-between">
                        <st-button
                            size="large"
                            variant="link"
                            :callback="cancel"
                            :disabled="loading"
                        >
                            {{ $t('TAXES.MODALS.CANCEL') }}
                        </st-button>
                        <st-button
                            size="large"
                            :callback="submit"
                            :spinner="loading"
                        >
                            {{ $t('TAXES.MODALS.SAVE') }}
                        </st-button>
                    </div>
                </template>
            </tax-form>
        </template>
    </st-modal>
</template>

<script>
import TaxForm from './TaxForm.vue';

export default {
    name: 'EditTaxModal',
    components: {
        TaxForm
    },
    props: {
        selectedItem: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
        },
    },
    methods: {
        show() {
            this.$refs['st-edit-tax-modal'].show();
        },
        hide() {
            this.$refs['st-edit-tax-modal'].hide();
        },
        submit(tax) {
            this.$emit('submit', tax);
        },
    },
}
</script>